import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {CostCenter} from "./cost-center.model"; // Assuming you have an environment file for API URL

@Injectable({
    providedIn: 'root'
})
export class CostCenterService {
    private apiUrl = `${environment.restApiUrl}cost-centers`; // Adjust to your actual API endpoint

    constructor(private http: HttpClient) { }

    /**
     * Fetches all cost centers for a given company.
     * @param owningCompanyId The ID of the owning company.
     * @returns An Observable of an array of CostCenter.
     */
    getAllCostCenters(owningCompanyId: number): Observable<CostCenter[]> {
        // Replace with actual API call
        return this.http.get<CostCenter[]>(`${this.apiUrl}/company/${owningCompanyId}`);
    }

    /**
     * Creates a new cost center.
     * @param costCenter The CostCenter object to create.
     * @returns An Observable of the created CostCenter.
     */
    createCostCenter(costCenter: CostCenter): Observable<CostCenter> {
        // Replace with actual API call
        return this.http.post<CostCenter>(this.apiUrl, costCenter);
    }

    /**
     * Updates an existing cost center.
     * @param costCenter The CostCenter object to update (must have an ID).
     * @returns An Observable of the updated CostCenter.
     */
    updateCostCenter(costCenter: CostCenter): Observable<CostCenter> {
        // Replace with actual API call
        if (!costCenter.id) {
            return new Observable(observer => observer.error('Cost Center ID is required for update.'));
        }
        return this.http.put<CostCenter>(`${this.apiUrl}/${costCenter.id}`, costCenter);
    }

    /**
     * Deletes a cost center by its ID.
     * @param id The ID of the cost center to delete.
     * @returns An Observable of the deletion response.
     */
    deleteCostCenter(id: number): Observable<any> {
        // Replace with actual API call
        return this.http.delete(`${this.apiUrl}/${id}`);
    }

    /**
     * Fetches a single cost center by its ID.
     * @param id The ID of the cost center.
     * @returns An Observable of the CostCenter.
     */
    getCostCenterById(id: number): Observable<CostCenter> {
        // Replace with actual API call
        return this.http.get<CostCenter>(`${this.apiUrl}/${id}`);
    }
}
